import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStatus, tenantId } from '../../../../api/client';
import GridLoader from '../../../../component/Controls/loaders/gridLoader';
import { createNewExperience, getAllExperience, getExperienceById, removeExperience, selectAllExperience, selectCreationStatus, selectModificationStatus, selectRemovalStatus, selectStatus, showExperienceFlyout, updateExperienceOptionsStatus, updateSingleData, updateStatus } from '../../reducerSlices/experienceSlice';
import ReactPlaceholder from 'react-placeholder';
import { Filter, GridComponent, Inject, Page, Sort, Resize, Toolbar, CommandColumn } from '@syncfusion/ej2-react-grids';
import ReactTooltip from 'react-tooltip';
import { messages } from '../../../../common/actionMessages';
import { show } from '../../../../component/Controls/alerts/reducerSlices/confirmAlertSlice';
import { isObjectArray } from '../../../../utilities/utilityFunctions';
import { getSkillGroupOptions, selectSkillGroupOptions, selectSkillGroupOptionsStatus } from '../../reducerSlices/skillGroupSlice';


function Experience() {

    const dispatch = useDispatch();

    const whereClause = {
        name: ""
    };

    const [dummyCards, setDummyCards] = useState([]);

    const experienceCreationStatus = useSelector(selectCreationStatus);
    const experienceModificationStatus = useSelector(selectModificationStatus);
    const experienceRemovalStatus = useSelector(selectRemovalStatus);

    const experience = useSelector(selectAllExperience);

    const skillGroupOptionsStatus = useSelector(selectSkillGroupOptionsStatus);
    const skillGroupOptions = useSelector(selectSkillGroupOptions);
    const experienceRequestStatus = useSelector(selectStatus);

    useEffect(() => {
        if (skillGroupOptionsStatus === fetchStatus.IDLE) {
            dispatch(getSkillGroupOptions({
                client: tenantId,
                serviceType: "TENANTADMIN",
                operation: "GETSKILLGROUPOPTIONS",
                payload: {
                    id: "",
                    data: JSON.stringify({ All: "false" })
                }
            }));
        }
    }, [skillGroupOptionsStatus]);

    useEffect(() => {
        if (experienceRequestStatus === fetchStatus.IDLE) {
            _loadExperiences(0, 0, 10, whereClause);
        }
    }, [experienceRequestStatus, dispatch]);

    let _dummyCards = [];

    useEffect(() => {
        if (experienceRequestStatus === fetchStatus.SUCCEEDED) {
            dispatch(updateStatus());
        }
    }, [experienceRequestStatus]);

    useEffect(() => {
        if (experienceRequestStatus === fetchStatus.LOADING) {
            for (let i = 0; i < 10; i++) {
                _dummyCards.push(
                    <div className="list-loading-content">
                        <ReactPlaceholder type='text' ready={false} rows={2} color='#E0E0E0'>
                        </ReactPlaceholder>
                    </div>
                );
            }
            setDummyCards(_dummyCards);
        }
    }, [experienceRequestStatus]);

    useEffect(() => {
        if (experienceRemovalStatus === fetchStatus.SUCCEEDED) {
            _loadExperiences(0, 0, 10, whereClause);
            if (experience && experience.Items && experience.Items.length > 0) {
                let item = experience.Get(0);
                let _experiences = item ? item.records : [];
                if (_experiences && Array.isArray(_experiences) && _experiences.length > 0) {
                    let _experience = _experiences[0];
                    if (_experience && _experience.id) {
                        _loadExperience(_experience.id, 0);
                    }
                }
                else {
                    dispatch(updateSingleData(undefined));
                }
            }
            else {
                dispatch(updateSingleData(undefined));
            }

            dispatch(updateExperienceOptionsStatus());
        }
    }, [experienceRemovalStatus]);

    const _loadExperience = async (id, page) => {
        await dispatch(getExperienceById({
            page: page,
            model: {
                client: tenantId,
                serviceType: "TENANTADMIN",
                operation: "GETSETTINGEXPERIENCEBYID",
                payload: {
                    id: id,
                    data: ""
                }
            }
        }));
    }

    // const _loadForm = async () => {
    //     await dispatch(getClientForm({
    //         client: tenantId,
    //         serviceType: "TENANTADMIN",
    //         operation: "GETFORMBYTYPE",
    //         payload: {
    //             id: "",
    //             data: "ClientForm"
    //         }
    //     }));
    // }

    const _loadExperiences = async (page, offset, limit, whereClause) => {
        await dispatch(getAllExperience({
            page: page,
            model: {
                client: tenantId,
                serviceType: "TENANTADMIN",
                operation: "GETSETTINGEXPERIENCE",
                payload: {
                    id: "",
                    data: JSON.stringify({
                        offset: offset,
                        limit: 1000,
                        where: whereClause
                    })
                }
            }
        }));
    }

    const onExperienceSelected = (e, id) => {
        e.preventDefault();
        _loadExperience(id, undefined);
        dispatch(showExperienceFlyout({
            createMode: false,
            editMode: true
        }));
    };

    const onDeleteClicked = (e, id) => {
        e.preventDefault();
        if (id) {
            dispatch(show({
                id: id,
                title: messages.confirmAlert.title,
                content: messages.confirmAlert.content.removal('Experience'),
                confirmedCallback: _removeExperience
            }));
        }
    };

    const onAddRecordClicked = (e) => {
        dispatch(createNewExperience());

        dispatch(showExperienceFlyout({
            createMode: true,
            editMode: false
        }));
    };

    const _removeExperience = async (id) => {
        await dispatch(removeExperience({
            client: tenantId,
            serviceType: "TENANTADMIN",
            operation: "DELETESETTINGEXPERIENCE",
            payload: {
                id: id,
                data: ""
            }
        }))
    };

    useEffect(() => {
        if (experienceCreationStatus === fetchStatus.SUCCEEDED) {
            _loadExperiences(0, 0, 10, whereClause);
        }
    }, [experienceCreationStatus]);

    useEffect(() => {
        if (experienceModificationStatus === fetchStatus.SUCCEEDED) {
            _loadExperiences(0, 0, 10, whereClause);
        }
    }, [experienceModificationStatus]);

    const addActionTemplate = (props) => {
        return <>
            <i className='fa fa-pencil' data-tip='Edit' title='Edit' onClick={(e) => onExperienceSelected(e, props.id)}></i>
            <i className='fa fa-trash ms-3' data-tip='Delete' title='Delete' onClick={(e) => onDeleteClicked(e, props ? props.id : "")}></i>
            <ReactTooltip place="bottom" type="info" effect="solid" className="c-tooltip" arrowColor='#0a253e' />
        </>
    }
    const gridRef = useRef(null);
    useEffect(() => {
        if (gridRef.current) {
            gridRef.current.refresh();
        }
    }, [experience, experienceRequestStatus]);

    const _geSkillGroupNameText = (skillGroup, id) => {
        if (isObjectArray(skillGroup)) {
            let _skillGroup = skillGroup.find(l => l.value === id);
            if (_skillGroup && _skillGroup.text) {
                return _skillGroup.text;
            }
        }
        return "";
    }

    const getSkillGroupName = (field, data, column) => {
        return _geSkillGroupNameText(skillGroupOptions, data["SkillGroupId"]);
    }
    
    const columns = [
        { field: 'ExperienceName', headerText: 'Skill Name', width: '100' },
        { field: 'Type', headerText: 'Field Type', width: '100' },
        { field: 'Status', headerText: 'Status', width: '100' },
        { field: 'SkillGroupId', headerText: 'Skill Group Name', width: '100', valueAccessor: getSkillGroupName},
        {
            headerText: 'Action',
            template: addActionTemplate,
            width: '50px',
        },
    ];


    return (
        <>
            {(experienceRequestStatus === fetchStatus.LOADING ||
                experienceRemovalStatus === fetchStatus.LOADING
            ) &&
                <div className="app-container-loader">
                    <GridLoader />
                </div>
            }
            <div className="row">
                <div className="col-md-6">
                    <span className="detail-container-title">Skills</span>
                </div>
                <div className="col-md-6 text-end">
                    <button className="c-btn dark-btn" type="button" data-tip='Create new skill' onClick={(e) => onAddRecordClicked(e)}>
                        <i className="fa fa-plus"></i>
                    </button>
                </div>
            </div>
            <div className="row p-3">
                <GridComponent ref={gridRef} dataSource={experience} allowPaging={true} allowSorting={true} allowResizing={true} width="100%" toolbar={['Search']} pageSettings={{ pageSize: 10, pageCount: 5 }} rowHeight={50} columns={columns} >
                    <Inject services={[Page, Sort, Filter, Resize, Toolbar, CommandColumn]} />
                </GridComponent>
            </div>
        </>
    )
}

export default Experience